import PropTypes from 'prop-types';
import React from 'react';

export const smoothScrollToRef = (ref, style, offset = 0) => {
  window.scrollTo({
    left: 0,
    top: ref.current.offsetTop - offset,
    behavior: style || 'smooth',
  });
};

/**
 * Provides a location to scroll to if needing to be a ref to
 * component
 *
 * @param props
 * @returns {*}
 * @constructor
 */
const ScrollTo = (props) => {
  return <div style={{ height: 0 }} ref={props.reference} {...props} />;
};

ScrollTo.propTypes = {
  /**
   * ref created by React.useRef
   */
  reference: PropTypes.object.isRequired,
};

export default ScrollTo;
